import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollAdvanceExporter  {
    _originalTypeClassName = "zERP.BO.PayrollAdvanceExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollAdvanceExporter.translate = translateService;
}
this.PayrollAdvanceExporterKey = null;
this._key = this.PayrollAdvanceExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PayrollAdvanceExporterKey:any;
get PayrollAdvanceExporterKey(): any {
    return this._PayrollAdvanceExporterKey;
  }
set PayrollAdvanceExporterKey(value: any) {
    this._PayrollAdvanceExporterKey = value;
    this._key = value;
  }

static GetCollectionVariables(calculation: any): any{let vars = new window['Map']();
let employeesChildren = [];
employeesChildren?.add({
Name: "CODE",Description: "Κωδικός",}
);
employeesChildren?.add({
Name: "SURNAME",Description: "Επώνυμο",}
);
employeesChildren?.add({
Name: "NAME",Description: "Όνομα",}
);
employeesChildren?.add({
Name: "FATHER_NAME",Description: "Όνομα Πατέρα",}
);
employeesChildren?.add({
Name: "CALCULATION_NAME",Description: "Τύπος Υπολογισμού",}
);
employeesChildren?.add({
Name: "ADVANCE_TYPE",Description: "Είδος Προκαταβολής",}
);
employeesChildren?.add({
Name: "ADVANCE_AMOUNT",Description: "Ποσό προκαταβολής",}
);
vars.set({
Name: "EMPLOYEES",Description: "Υπάλληλοι",IsCollection: true,Children: employeesChildren,}
, Joove.Common.cast(calculation?.Employees, "System.Collections.List"));
return vars;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollAdvanceExporterKey == null || $this.PayrollAdvanceExporterKey == 0;
            }


}